export function mapServerData(firstElement, res, data) {
    return {
        uslId: firstElement ? firstElement.kcpGroup.usl.id : data.usl.id,
        kcpId: firstElement ? firstElement.kcpGroup.id : data.kcp.id,
        foId: firstElement ? firstElement.fo.id : data.fo.id,
        data: firstElement ? res : [],
    }
}

export function mapServerSumData(res, data) {
    return {
        kcpId: data.kcp.id,
        data: res ?? {},
    }
}

export function returnErrorsForSumData(data = {}) {
    try {
        const names = {
            zayavkaValueOchno: {text: 'очной', compareDataField: 'rfZayavkaValueOchno'},
            zayavkaValueOchnoZaochno: {text: 'очно-заочной', compareDataField: 'rfZayavkaValueOchnoZaochno'},
            zayavkaValueZaochno:  {text: 'заочной', compareDataField: 'rfZayavkaValueZaochno'},
        };
        return Object.keys(names).reduce( (acc, key) => {
                if (data[key] < data[names[key].compareDataField])
                    acc.push(`Запланированный объем КЦП превышает суммарную заявка всех участников конкурса КЦП 24/25 по ${names[key].text} форме`)
                return acc;
            },
            [])
    }catch (e) {
        console.error('errors calc error', e)
    }

}